@if (detail(); as det) {
  @if (!appSettings.isMobile()) {
    <div class="panel p-2 mt-3 mb-0">
      @if (mode() !== formMode.VIEW) {
        <p class="text-muted small mb-2 px-1">
          Suba todos los documentos requeridos y luego pulse <strong>Dejar en revisión</strong>. El envío de la solicitud es aparte, con todos los daños.
        </p>
      } @else if (canEditDetails()) {
        <p class="text-muted small mb-2 px-1">
          Revise cada archivo. Si uno está mal, pida corrección: la solicitud sigue abierta y la entidad solo reemplaza ese archivo.
        </p>
      } @else if (canReplaceObserved()) {
        <p class="text-warning small mb-2 px-1">
          <i class="fas fa-exclamation-circle me-1"></i>Hay archivos observados. Reemplace solo esos; el resto no se toca.
        </p>
      }

      @if (showDocumentUpload()) {
        <app-document-group
          [documents]="detailDocuments()"
          [mode]="det.statusSlug === 'REVIEWING' ? formMode.VIEW : formMode.EDIT"
          [immediateUpload]="true"
          [layout]="'table'"
          [embedded]="true"
          (onUploadFile)="uploadDetailDocument($event)"
          (onDocumentUpdate)="documentUploaded.emit()"
          (onDeleteDocument)="removeOptionalDocument($event)">
        </app-document-group>

        @if (canComplementDocuments) {
          <div class="row g-2 align-items-end mt-3 border-top pt-3 px-1">
            <div class="col-sm-8 col-12">
              <label class="form-label small fw-bold text-muted mb-1">Complementar documentos</label>
              <app-sheet-select
                [items]="availableOptionalDocs()"
                bindLabel="name"
                bindValue="typeSlug"
                title="Documento complementario"
                placeholder="Seleccione documento..."
                [(ngModel)]="selectedOptionalTypeSlug"
                [clearable]="true"
                [searchable]="availableOptionalDocs().length > 5">
              </app-sheet-select>
            </div>
            <div class="col-sm-4 col-12 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                [disabled]="!selectedOptionalTypeSlug"
                (click)="addOptionalDocument()">
                <i class="fas fa-plus me-1"></i> Agregar
              </button>
            </div>
          </div>
        }
      } @else {
        <app-document-approval
          [categoriesData]="detailDocuments()?.categories"
          [canApprove]="canEditDetails()"
          [canFinalApprove]="canFinalApproveDocs()"
          [canReplace]="canReplaceObserved()"
          [origin]="'CLAIM'"
          (onReviewCompleted)="onEvidenceReviewCompleted()"
          (onUploadFile)="uploadDetailDocument($event)">
        </app-document-approval>
      }
    </div>
  } @else {
    <div class="row mb-2 border-top pt-3 mt-3">
      <div class="col-12">
        <label class="fw-semibold text-muted small text-uppercase d-block mb-1">Evidencias y documentos adjuntos</label>
        @if (mode() !== formMode.VIEW) {
          <p class="text-muted small mb-2">
            Suba todos los documentos requeridos y luego pulse <strong>Dejar en revisión</strong>. El envío de la solicitud es aparte, con todos los daños.
          </p>
        } @else if (canEditDetails()) {
          <p class="text-muted small mb-2">
            Revise cada archivo. Si uno está mal, pida corrección: la solicitud sigue abierta y la entidad solo reemplaza ese archivo.
          </p>
        } @else if (canReplaceObserved()) {
          <p class="text-warning small mb-2">
            <i class="fas fa-exclamation-circle me-1"></i>Hay archivos observados. Reemplace solo esos; el resto no se toca.
          </p>
        }

        @if (showDocumentUpload()) {
          <app-document-group
            [documents]="detailDocuments()"
            [mode]="det.statusSlug === 'REVIEWING' ? formMode.VIEW : formMode.EDIT"
            [immediateUpload]="true"
            [layout]="'table'"
            [embedded]="true"
            (onUploadFile)="uploadDetailDocument($event)"
            (onDocumentUpdate)="documentUploaded.emit()"
            (onDeleteDocument)="removeOptionalDocument($event)">
          </app-document-group>

          @if (canComplementDocuments) {
            <div class="row g-2 align-items-end mt-3 border-top pt-3">
              <div class="col-sm-8 col-12">
                <label class="form-label small fw-bold text-muted mb-1">Complementar documentos</label>
                <app-sheet-select
                  [items]="availableOptionalDocs()"
                  bindLabel="name"
                  bindValue="typeSlug"
                  title="Documento complementario"
                  placeholder="Seleccione documento..."
                  [(ngModel)]="selectedOptionalTypeSlug"
                  [clearable]="true"
                  [searchable]="availableOptionalDocs().length > 5">
                </app-sheet-select>
              </div>
              <div class="col-sm-4 col-12 text-end">
                <button type="button" class="btn btn-outline-primary w-100"
                  [disabled]="!selectedOptionalTypeSlug"
                  (click)="addOptionalDocument()">
                  <i class="fas fa-plus me-1"></i> Agregar
                </button>
              </div>
            </div>
          }
        } @else {
          <app-document-approval
            [categoriesData]="detailDocuments()?.categories"
            [canApprove]="canEditDetails()"
            [canFinalApprove]="canFinalApproveDocs()"
            [canReplace]="canReplaceObserved()"
            [origin]="'CLAIM'"
            (onReviewCompleted)="onEvidenceReviewCompleted()"
            (onUploadFile)="uploadDetailDocument($event)">
          </app-document-approval>
        }
      </div>
    </div>
  }
}
